import { createSelector } from "reselect";

const currentState = (state) => state;

export const retrieveActionRequestLoadingStatus = createSelector(
  currentState,
  (st) => st.loadingActionRequests
);
